import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "textHighlight",
})
export class TextHighlightPipe implements PipeTransform {
  transform(text: string, searchString: string): string {
    if (text !== undefined && searchString) {
      // TO-DO: MIGHT NEED THIS: searchString.replace(/([ #;?%&,.\-_`+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
      const regexSearchString = searchString.replace(
        /([ #;?%&,.\-_`+*~:"!^$[\]()=>|@])/g,
        "\\$1",
      );
      text = text.replace(
        new RegExp(`(${regexSearchString})`, "gi"),
        '<span class="highlighted">$1</span>',
      );
    }
    return text;
  }
}
